import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import TabPanel from './vertical-tab-panel';

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up('sm')]: {
      display: 'flex'
    }
  },
  tabs: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.up('sm')]: {
      borderRight: `1px solid ${theme.palette.divider}`,
      borderBottom: 'none'
    },
  },
}));

const VerticalTabs = ({ tabs, currentTab, children, onChange, width }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Tabs
        orientation={isWidthUp('sm', width) ? "vertical" : "horizontal"}
        variant="scrollable"
        value={currentTab}
        onChange={onChange}
        aria-label="Vertical tabs"
        className={classes.tabs}
      >
        {tabs.map(({ label, tab }) => (
          <Tab
            key={tab}
            label={label}
            value={tab}
            id={`vertical-tab-${tab}`}
            aria-controls={`vertical-tabpanel-${tab}`}
          />
        ))}
      </Tabs>
      {children}
    </div>
  );
};

VerticalTabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    tab: PropTypes.string
  })).isRequired,
  currentTab: PropTypes.any.isRequired,
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  onChange: PropTypes.func.isRequired,
  width: PropTypes.string
};

VerticalTabs.TabPanel = TabPanel;

export default withWidth()(VerticalTabs);
